(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var relatedProductSectionRequests = new WeakMap();

var fetchRelatedProductSection = function(url, signal) {
  return fetch(url, { credentials: 'same-origin', signal: signal }).then(function(response) {
    if (!response.ok) { throw new Error('Related products request failed'); }
    return response.text();
  }).then(function(html) {
    var container = document.createElement('div');
    container.innerHTML = html;
    return container;
  });
};

var readRelatedProductCandidates = function(container) {
  return Array.from(container.querySelectorAll('[data-related-product-candidate]')).map(function(candidate) {
    return {
      id: candidate.dataset.productId,
      url: candidate.dataset.productUrl,
      priceBand: candidate.dataset.priceBand || '',
      isBestSeller: candidate.dataset.bestSeller === 'true',
      isNew: candidate.dataset.new === 'true'
    };
  });
};

var fetchRelatedProductCard = function(candidate, cardSectionId, signal) {
  var url = new URL(candidate.url, window.location.origin);
  url.search = '';
  url.searchParams.set('section_id', cardSectionId);

  return fetchRelatedProductSection(url.toString(), signal).then(function(container) {
    var card = container.querySelector('[data-related-product-card]');
    return card ? card.firstElementChild : null;
  });
};

var renderRelatedProductCards = function(section, cards) {
  var grid = section.querySelector('.product-grid');
  if (!grid || cards.length === 0) { return; }

  var mobileCarousel = section.dataset.mobileCarousel === 'true';
  var fragment = document.createDocumentFragment();

  cards.forEach(function(card) {
    if (mobileCarousel) {
      var sliderItem = document.createElement('div');
      sliderItem.className = 'slider__item';
      sliderItem.appendChild(card);
      fragment.appendChild(sliderItem);
    } else {
      fragment.appendChild(card);
    }
  });

  grid.replaceChildren(fragment);
  section.hidden = false;
  section.querySelectorAll('carousel-slider').forEach(function(carousel) {
    if (typeof carousel.refresh === 'function') { carousel.refresh(); }
  });
};

var loadRelatedProductsIntoSection = async function(section) {
  if (!section || !section.dataset.searchUrl) { return; }

  var previousController = relatedProductSectionRequests.get(section);
  if (previousController) { previousController.abort(); }

  var controller = new AbortController();
  relatedProductSectionRequests.set(section, controller);

  var maxProducts = Number(section.dataset.maxProducts) || 4;
  var currentProductId = section.dataset.currentProductId;
  var currentPriceBand = section.dataset.currentPriceBand;
  var selectedCandidates = [];
  var selectedIds = new Set([currentProductId]);

  var addCandidates = function(candidates, predicate) {
    candidates.forEach(function(candidate) {
      if (selectedCandidates.length >= maxProducts || selectedIds.has(candidate.id)) { return; }
      if (predicate && !predicate(candidate)) { return; }
      selectedIds.add(candidate.id);
      selectedCandidates.push(candidate);
    });
  };

  try {
    try {
      var searchContainer = await fetchRelatedProductSection(section.dataset.searchUrl, controller.signal);
      var searchCandidates = readRelatedProductCandidates(searchContainer);

      addCandidates(searchCandidates, function(candidate) {
        return candidate.isBestSeller && candidate.priceBand === currentPriceBand;
      });
      addCandidates(searchCandidates, function(candidate) {
        return candidate.isNew;
      });
      addCandidates(searchCandidates);
    } catch (searchError) {
      if (searchError.name === 'AbortError') { throw searchError; }
      console.warn('Unable to search related products.', searchError);
    }

    if (selectedCandidates.length < maxProducts && section.dataset.recommendationsUrl) {
      try {
        var fallbackContainer = await fetchRelatedProductSection(section.dataset.recommendationsUrl, controller.signal);
        addCandidates(readRelatedProductCandidates(fallbackContainer));
      } catch (fallbackError) {
        if (fallbackError.name === 'AbortError') { throw fallbackError; }
        console.warn('Unable to load fallback product recommendations.', fallbackError);
      }
    }

    if (selectedCandidates.length < maxProducts && section.dataset.genderSearchUrl) {
      try {
        var genderSearchContainer = await fetchRelatedProductSection(section.dataset.genderSearchUrl, controller.signal);
        addCandidates(readRelatedProductCandidates(genderSearchContainer));
      } catch (genderSearchError) {
        if (genderSearchError.name === 'AbortError') { throw genderSearchError; }
        console.warn('Unable to load gender-and-style related products.', genderSearchError);
      }
    }

    if (selectedCandidates.length === 0) { return; }

    var cards = await Promise.all(selectedCandidates.map(function(candidate) {
      return fetchRelatedProductCard(candidate, section.dataset.cardSectionId, controller.signal);
    }));
    cards = cards.filter(Boolean);

    if (cards.length !== selectedCandidates.length) { return; }
    renderRelatedProductCards(section, cards);
  } catch (error) {
    if (error.name !== 'AbortError') {
      console.warn('Unable to render related products.', error);
    }
  } finally {
    if (relatedProductSectionRequests.get(section) === controller) {
      relatedProductSectionRequests.delete(section);
    }
  }
};

document.addEventListener('shopify:section:load', function(event) {
  loadRelatedProductsIntoSection(event.target.querySelector('.related-products[data-search-url]'));
});

document.addEventListener('shopify:section:unload', function(event) {
  var section = event.target.querySelector('.related-products[data-search-url]');
  var controller = section && relatedProductSectionRequests.get(section);
  if (controller) { controller.abort(); }
});

document.querySelectorAll('.related-products[data-search-url]').forEach(function(section) {
  loadRelatedProductsIntoSection(section);
});

  } catch(e) { console.error(e); }
})();
})();
